// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"405":"Weixin","463":"accountCenter"}[chunkId] || chunkId) + "." + {"405":"4c63f624","463":"5d192f9e","513":"28a556a1"}[chunkId] + ".js";
};